// extracted by mini-css-extract-plugin
export default {"list":"SocailIcons_list__F1TdG","item":"SocailIcons_item__YhXg-","icon":"SocailIcons_icon__sOToR"};